/** Keep provider validation messages, but make transport/service errors useful. */
export function getAuthErrorMessage(error: { message?: string; status?: number; code?: string }) {
  if (error.code === "pkce_code_verifier_not_found" || error.code === "bad_code_verifier") {
    return "Open the email link in the browser where you requested it, or request a new link below. You can also sign in with your password.";
  }
  if (error.code === "otp_expired") {
    return "This sign-in link is invalid or has expired. Request a new one below.";
  }
  if (error.code === "email_not_confirmed") {
    return "Confirm your email before signing in. Check your inbox and spam folder for the confirmation message.";
  }
  const message = error.message?.trim();
  if (!message || message === "{}" || (error.status !== undefined && error.status >= 500)) {
    return "Account access is temporarily unavailable. Try again shortly. Your details are still here.";
  }
  return message;
}
